module.exports = __webpack_public_path__ + "static/Retail-Photo2-18b4d3c9b6d6676dd1f7c6563ed1c647.png";